import React, { Fragment, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Context from "src/context/context";

const Protected = ({ Component }) => {
    const { token, setToken, user, setUser } = useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        // If token is null or user is undefined (or unauthenticated state)
        if (!token) {
            navigate("/login"); // Redirect to login
        }
    }, [token, navigate]);

    // Optionally, handle loading state or authentication check (e.g., token expiry)
    if (token === null) {
        return <div>Loading...</div>;  // Or any loading spinner
    }

    return (
        <Fragment>
            {/* Render the protected component if token is available */}
            <Component />
        </Fragment>
    );
};

export default Protected;
